import script from "./couponDetails.vue?vue&type=script&setup=true&lang=jsx"
export * from "./couponDetails.vue?vue&type=script&setup=true&lang=jsx"

import "./couponDetails.vue?vue&type=style&index=0&id=7d56c992&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d56c992"]])

export default __exports__